import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  D,
  h,
  ke
} from "./chunk.FCKNEYTX.js";
import {
  n
} from "./chunk.BBN2ZB42.js";
import {
  i,
  r
} from "./chunk.FAJKIEWS.js";
import {
  __decorateClass
} from "./chunk.I4IFG4JG.js";

// src/components/jb-contact-item/jb-contact-item.scss?inline
var jb_contact_item_default = i`*,
*::before,
*::after {
  box-sizing: border-box;
}

div,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
ol,
ul,
li,
form,
legend,
label,
table,
header,
footer,
nav,
section,
figure {
  margin: 0;
  padding: 0;
}

a {
  color: inherit;
}

/* COLOR SETTINGS */
/* shadows */
:host {
  --spacing-none: 0;
  --spacing-base: 4px;
  --spacing-3xs: 8px;
  --spacing-2xs: 12px;
  --spacing-xs: 16px;
  --spacing-s: 20px;
  --spacing-sm: 20px;
  --spacing-m: 24px;
  --spacing-lm: 28px;
  --spacing-l: 32px;
  --spacing-xl: 32px;
  --spacing-2xl: 36px;
  --spacing-3xl: 36px;
  --spacing-4xl: 72px;
  --spacing-small: var(--spacing-lm);
  --spacing-medium: var(--spacing-3xl);
  --spacing-big: var(--spacing-4xl);
  --spacing-gap: 16px;
}

@media screen and (width >= 1281px) {
  :host {
    --spacing-sm: 24px;
    --spacing-m: 32px;
    --spacing-lm: 36px;
    --spacing-l: 40px;
    --spacing-xl: 48px;
    --spacing-2xl: 64px;
    --spacing-3xl: 72px;
    --spacing-4xl: 144px;
    --spacing-small: var(--spacing-lm);
    --spacing-medium: var(--spacing-3xl);
    --spacing-big: var(--spacing-4xl);
    --spacing-gap: 40px;
  }
}
/* special measurements */
/* stylelint-disable */
/* stylelint-enable */
.name, .location {
  font-family: var(--theme-font-bold-family, VerlagSSm, Tahoma, sans-serif);
  font-weight: var(--theme-font-bold-weight, 700);
}

span.avatar {
  font-family: var(--theme-font-regular-family, VerlagSSm, Tahoma, sans-serif);
  font-weight: var(--theme-font-regular-weight, 400);
}

.title,
.description, .contactbox {
  font-family: var(--theme-font-light-family, VerlagSSm, Tahoma, sans-serif);
  font-style: normal;
  font-weight: var(--theme-font-light-weight, 300);
}

.location {
  font-size: var(--theme-typo-uppercase-700-fontsize, 0.688rem);
  letter-spacing: var(--theme-typo-uppercase-700-letterspacing, 0.063rem);
  line-height: var(--theme-typo-uppercase-700-lineheight, 1rem);
  text-transform: uppercase;
}

.contactbox {
  font-size: var(--theme-typo-p-small-desktop-fontsize, 1rem);
  line-height: var(--theme-typo-p-small-desktop-lineheight, 1.625rem);
}

.name {
  font-size: var(--theme-typo-p-small-highlight-desktop-fontsize, 1rem);
  line-height: var(--theme-typo-p-small-highlight-desktop-lineheight, 1.625rem);
}

.title,
.description {
  font-size: var(--theme-typo-p-mini-desktop-fontsize, 0.813rem);
  line-height: var(--theme-typo-p-mini-desktop-lineheight, 1.25rem);
}

:host {
  --spacing-none: 0;
  --spacing-base: 4px;
  --spacing-3xs: 8px;
  --spacing-2xs: 12px;
  --spacing-xs: 16px;
  --spacing-s: 20px;
  --spacing-sm: 20px;
  --spacing-m: 24px;
  --spacing-lm: 28px;
  --spacing-l: 32px;
  --spacing-xl: 32px;
  --spacing-2xl: 36px;
  --spacing-3xl: 36px;
  --spacing-4xl: 72px;
  --spacing-small: var(--spacing-lm);
  --spacing-medium: var(--spacing-3xl);
  --spacing-big: var(--spacing-4xl);
  --spacing-gap: 16px;
}

@media screen and (width >= 1281px) {
  :host {
    --spacing-sm: 24px;
    --spacing-m: 32px;
    --spacing-lm: 36px;
    --spacing-l: 40px;
    --spacing-xl: 48px;
    --spacing-2xl: 64px;
    --spacing-3xl: 72px;
    --spacing-4xl: 144px;
    --spacing-small: var(--spacing-lm);
    --spacing-medium: var(--spacing-3xl);
    --spacing-big: var(--spacing-4xl);
    --spacing-gap: 40px;
  }
}
/* special measurements */
:host {
  color: var(--host-color, #141e55);
}

:host {
  background-color: rgb(var(--theme-color-blue-light, 231 232 238));
  block-size: min-content;
  container-type: inline-size;
  display: block;
  --_avatar-size: 40px;
}

a {
  align-items: center;
  display: flex;
  gap: var(--spacing-2xs);
  text-decoration: none;
}
a span {
  border-bottom: 1px solid rgb(var(--theme-color-royal-blue, 20 30 85)/var(--theme-opacity-20, 0.2));
  transition: border-color 0.1s ease-in-out;
  word-break: break-all;
}
a:hover span {
  border-block-end-color: rgb(var(--theme-color-royal-blue, 20 30 85)/1);
}

.wrapper {
  color: rgb(var(--theme-color-royal-blue, 20 30 85));
  display: grid;
  gap: var(--spacing-2xs);
  grid-template-columns: 1fr;
  padding: var(--spacing-s);
  --_left-start-column: 1;
}
.wrapper:has(.avatar) {
  --_left-start-column: 2;
}

jb-picture {
  padding: var(--spacing-s);
  padding-block-end: 0;
}

.namebox,
.contactbox {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-base);
}

.contactbox {
  gap: var(--spacing-3xs);
}

jb-button-tertiary {
  margin-block-start: calc(var(--spacing-s) - var(--spacing-3xs));
}

.avatar {
  aspect-ratio: 1;
  background-color: rgb(var(--theme-color-royal-blue, 20 30 85));
  block-size: var(--_avatar-size);
  border-radius: 80px;
  inline-size: var(--_avatar-size);
  overflow: hidden;
}

span.avatar {
  color: white;
  display: grid;
  font-size: 1rem;
  line-height: 1rem;
  place-content: center;
  text-transform: uppercase;
}

jb-picture.avatar {
  display: block;
  padding: 0;
}

.location {
  font-weight: 400;
}

.avatar,
.namebox,
.description,
.contactbox {
  grid-column: 1/-1;
}

@container (width > 375px) {
  .wrapper {
    grid-template-columns: 1fr;
  }
  .wrapper:has(.avatar) {
    grid-template-columns: var(--_avatar-size) 1fr;
  }
  .wrapper .avatar {
    grid-column: 1;
  }
  .wrapper .namebox,
  .wrapper .description,
  .wrapper .contactbox {
    grid-column: var(--_left-start-column)/-1;
  }
}
@container (width > 480px) {
  .wrapper {
    --_avatar-size: 64px;
  }
  .wrapper .avatar {
    font-size: 1.5rem;
    grid-column: 1;
    line-height: 1.5rem;
  }
}
@container (width > 600px) {
  jb-picture {
    display: none;
  }
  .wrapper {
    gap: var(--spacing-l) var(--spacing-s);
    grid-template-columns: repeat(2, 1fr);
    padding: var(--spacing-m);
  }
  .wrapper:has(.avatar) {
    grid-template-columns: var(--_avatar-size) repeat(2, 1fr);
  }
  .wrapper .namebox {
    grid-column: var(--_left-start-column);
  }
  .wrapper .contactbox {
    grid-column: calc(var(--_left-start-column) + 1);
    grid-row: 1;
  }
  .wrapper .description {
    grid-column: 1/-1;
  }
}
@container (width > 960px) {
  .wrapper {
    grid-template-columns: repeat(3, 1fr);
  }
  .wrapper .contactbox {
    grid-column: calc(var(--_left-start-column) + 1);
  }
  .wrapper .description {
    grid-column: calc(var(--_left-start-column) + 2);
  }
  .wrapper:has(.avatar) {
    grid-template-columns: var(--_avatar-size) repeat(3, 1fr);
  }
}`;

// src/components/jb-contact-item/jb-contact-item.ts
var JbContactItem = class extends h {
  render() {
    return ke`
      ${this.picture ? ke`<jb-picture
            .alt=${this.picture.alt}
            .imgData=${this.picture.imgData}
          ></jb-picture>` : D}
      <div class="wrapper">
        ${this.avatar ? ke`<jb-picture
              class="avatar"
              .imgData=${this.avatar.imgData}
              .fit=${"cover"}
            ></jb-picture>` : D}
        ${!this.avatar && this.initials ? ke`<span class="avatar">${this.initials.substring(0, 2)}</span>` : D}
        ${this.location || this.name || this.title ? ke`<div class="namebox">
              ${this.location ? ke`<span class="location">${this.location}</span>` : D}
              ${this.name ? ke`<span class="name">${this.name}</span>` : D}
              ${this.jobTitle ? ke`<span class="title">${this.jobTitle}</span>` : D}
            </div>` : D}
        ${this.description ? ke`<span class="description">${this.description}</span>` : D}
        ${this.phone || this.email || this.profileLink ? ke`<div class="contactbox">
              ${this.phone ? ke`<a
                    class="phone"
                    href="tel:${this.phone}"
                    ><jb-phone-icon></jb-phone-icon><span>${this.phone}</span></a
                  >` : D}
              ${this.email ? ke`<a
                    class="mail"
                    href="mailto:${this.email}"
                    ><jb-mail-icon></jb-mail-icon><span>${this.email}</span></a
                  >` : D}
              ${this.profileLink ? ke`<jb-button-tertiary .link=${this.profileLink.link}
                    >${this.profileLink.linkText}</jb-button-tertiary
                  >` : D}
              ${this.phone || this.email || this.profileLink ? ke`</div>` : D}
            </div>` : D}
      </div>
    `;
  }
};
JbContactItem.styles = r(jb_contact_item_default);
__decorateClass([
  n({ type: Object })
], JbContactItem.prototype, "avatar", 2);
__decorateClass([
  n()
], JbContactItem.prototype, "description", 2);
__decorateClass([
  n()
], JbContactItem.prototype, "email", 2);
__decorateClass([
  n()
], JbContactItem.prototype, "initials", 2);
__decorateClass([
  n()
], JbContactItem.prototype, "jobTitle", 2);
__decorateClass([
  n()
], JbContactItem.prototype, "location", 2);
__decorateClass([
  n()
], JbContactItem.prototype, "name", 2);
__decorateClass([
  n()
], JbContactItem.prototype, "phone", 2);
__decorateClass([
  n({ type: Object })
], JbContactItem.prototype, "picture", 2);
__decorateClass([
  n({ type: Object })
], JbContactItem.prototype, "profileLink", 2);
JbContactItem = __decorateClass([
  customElement("jb-contact-item")
], JbContactItem);

export {
  JbContactItem
};
